import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=6a8be952&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=ts&"
export * from "./SignUp.vue?vue&type=script&lang=ts&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=6a8be952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8be952",
  null
  
)

component.options.__file = "SignUp.vue"
export default component.exports